<div class="container flex flex-col gap-[12px] justify-start items-start">
  <div class="flex flex-row gap-[12px] justify-start items-center">
    <div class="header">
      {{ '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.HEADER' | translate }}
    </div>
    <app-pill [type]="pillType.brand">
      {{ '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.CHIP_HEADER' | translate }}
    </app-pill>
  </div>
  <div
    class="flex flex-row lt-md:flex-col lt-md:gap-[12px] justify-between items-center lt-md:justify-start lt-md:items-start"
  >
    <div class="description flex-[70%] max-w-[70%] lt-md:flex-[100%] lt-md:max-w-[100%]">
      {{ '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.DESCRIPTION' | translate }}
    </div>

    <button
      *ngIf="isFreezeFrameErrorOccurred"
      mat-raised-button
      color="primary"
      gtm="onStart"
      gtmAction="Retry freeze frame vdd read"
      gtmCategory="guidedTroubleshootingPage"
      (click)="retryVddRead()"
    >
      <span>{{ 'GENERAL.BUTTON.TRY_AGAIN' | translate }}</span>
      <mat-icon>refresh</mat-icon>
    </button>

    <button
      *ngIf="isLiveVddErrorOccurred"
      mat-raised-button
      color="primary"
      gtm="onStart"
      gtmAction="Retry otx sequence execution"
      gtmCategory="guidedTroubleshootingPage"
      (click)="retrySequence()"
    >
      <span>{{ 'GENERAL.BUTTON.TRY_AGAIN' | translate }}</span>
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
